import React from 'react';
import "../../styles/About/About.css";

const Photo = () => {
  return (
    <div className="about-Banner">
      <div className="about-Banner-content">
        <h4 className="about-Banner-content-h4">About us</h4>
        
      </div>
    </div>
  );
  };
  
  
  export default Photo;